export const adTypes = [
  { name: 'Selecione uma opção', value: ''},
  { name: 'Tela inicial do calendário', value: 'home'},
  { name: 'Calculadora', value: 'calculator'},
  { name: 'Estado', value: 'location'}
]
